import script from "./carousel.vue?vue&type=script&setup=true&lang=js"
export * from "./carousel.vue?vue&type=script&setup=true&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=5e355c87&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e355c87"]])

export default __exports__